// extracted by mini-css-extract-plugin
module.exports = {"modalCLass":"Ineligible-claim_modalCLass__24Tmn","modalHeader":"Ineligible-claim_modalHeader__2AAWF","p20":"Ineligible-claim_p20__1rhdr","footer":"Ineligible-claim_footer__2olVB"};